// CB:BEGIN settings-save-bar-component
import React from 'react';

interface SettingsSaveBarProps {
  dirty: boolean;
  saving: boolean;
  error: string | null;
  lastSavedAt: Date | null;
  onSave: () => void;
  onRevert: () => void;
}

export function SettingsSaveBar({ 
  dirty, 
  saving, 
  error, 
  lastSavedAt, 
  onSave, 
  onRevert 
}: SettingsSaveBarProps) {
  return (
    <div style={{ 
      marginTop: '32px',
      paddingTop: '24px',
      borderTop: '1px solid #e2e8f0'
    }}>
      {error && !error.startsWith('✅') && (
        <div style={{
          padding: '12px 16px',
          background: '#fef2f2',
          color: '#dc2626',
          borderRadius: '8px',
          marginBottom: '16px',
          fontSize: '14px',
          border: '1px solid #fecaca',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <span>{error}</span>
          <button
            type="button"
            onClick={onSave}
            disabled={saving}
            style={{
              marginLeft: '12px',
              padding: '4px 12px',
              background: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: saving ? 'not-allowed' : 'pointer',
              fontSize: '13px',
              fontWeight: '500',
              opacity: saving ? 0.5 : 1
            }}
          >
            Retry
          </button>
        </div>
      )}

      {error && error.startsWith('✅') && (
        <div style={{
          padding: '12px 16px',
          background: '#f0fdf4',
          color: '#16a34a',
          borderRadius: '8px',
          marginBottom: '16px',
          fontSize: '14px',
          border: '1px solid #86efac'
        }}>
          {error}
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
        <div style={{ flex: 1 }}>
          {dirty && (
            <div style={{ fontSize: '14px', color: '#f59e0b', fontWeight: '500' }}>
              Unsaved changes
            </div>
          )}
          {!dirty && lastSavedAt && (
            <div style={{ fontSize: '13px', color: '#64748b' }}>
              Last saved {lastSavedAt.toLocaleTimeString()}
            </div>
          )}
        </div>
        
        <div style={{ display: 'flex', gap: '8px' }}>
          {dirty && (
            <button
              type="button"
              onClick={onRevert}
              disabled={saving}
              style={{
                padding: '8px 16px',
                background: 'transparent',
                color: '#64748b',
                border: '1px solid #cbd5e1',
                borderRadius: '6px',
                cursor: saving ? 'not-allowed' : 'pointer',
                fontWeight: '500',
                fontSize: '14px',
                opacity: saving ? 0.5 : 1
              }}
            >
              Revert
            </button>
          )}
          
          <button
            type="button"
            onClick={onSave}
            disabled={!dirty || saving}
            style={{
              padding: '8px 16px',
              background: (!dirty || saving) ? '#cbd5e1' : '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: (!dirty || saving) ? 'not-allowed' : 'pointer',
              fontWeight: '500',
              fontSize: '14px',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => {
              if (dirty && !saving) {
                e.currentTarget.style.background = '#1d4ed8';
              }
            }}
            onMouseLeave={(e) => {
              if (dirty && !saving) {
                e.currentTarget.style.background = '#2563eb';
              }
            }}
          >
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
}
// CB:END settings-save-bar-component

